'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = require('vue');

var Vue = _interopRequireWildcard(_vue);

var _kendoBaseComponentsVueWrapper = require('@progress/kendo-base-components-vue-wrapper');

var _KendoChartBase = require('../KendoChartBase');

var _KendoChartBase2 = _interopRequireDefault(_KendoChartBase);

var _AxisDefaults = require('../KendoChartBase/AxisDefaults');

var _AxisDefaults2 = _interopRequireDefault(_AxisDefaults);

var _CategoryAxis = require('../KendoChartBase/CategoryAxis');

var _CategoryAxis2 = _interopRequireDefault(_CategoryAxis);

var _ChartArea = require('../KendoChartBase/ChartArea');

var _ChartArea2 = _interopRequireDefault(_ChartArea);

var _Legend = require('../KendoChartBase/Legend');

var _Legend2 = _interopRequireDefault(_Legend);

var _Panes = require('../KendoChartBase/Panes');

var _Panes2 = _interopRequireDefault(_Panes);

var _Pannable = require('../KendoChartBase/Pannable');

var _Pannable2 = _interopRequireDefault(_Pannable);

var _Pdf = require('../KendoChartBase/Pdf');

var _Pdf2 = _interopRequireDefault(_Pdf);

var _PlotArea = require('../KendoChartBase/PlotArea');

var _PlotArea2 = _interopRequireDefault(_PlotArea);

var _Series = require('../KendoChartBase/Series');

var _Series2 = _interopRequireDefault(_Series);

var _SeriesDefaults = require('../KendoChartBase/SeriesDefaults');

var _SeriesDefaults2 = _interopRequireDefault(_SeriesDefaults);

var _Title = require('../KendoChartBase/Title');

var _Title2 = _interopRequireDefault(_Title);

var _Tooltip = require('../KendoChartBase/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _ValueAxis = require('../KendoChartBase/ValueAxis');

var _ValueAxis2 = _interopRequireDefault(_ValueAxis);

var _XAxis = require('../KendoChartBase/XAxis');

var _XAxis2 = _interopRequireDefault(_XAxis);

var _YAxis = require('../KendoChartBase/YAxis');

var _YAxis2 = _interopRequireDefault(_YAxis);

var _Zoomable = require('../KendoChartBase/Zoomable');

var _Zoomable2 = _interopRequireDefault(_Zoomable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    mixins: [_KendoChartBase2.default, _kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _AxisDefaults2.default, _CategoryAxis2.default, _ChartArea2.default, _Legend2.default, _Panes2.default, _Pannable2.default, _Pdf2.default, _PlotArea2.default, _Series2.default, _SeriesDefaults2.default, _Title2.default, _Tooltip2.default, _ValueAxis2.default, _XAxis2.default, _YAxis2.default, _Zoomable2.default],
    emits: {
        'kendowidgetready': null
    },
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    mounted: function mounted() {
        kendo.jQuery(this.$el).kendoChart(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    }
};